import { Job } from '../../models/job.model';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { tileLayer } from 'leaflet';
import { Store } from '@ngrx/store';
import * as fromUnit from '../../../settings-module/reducers';
import { take } from 'rxjs/operators';
import { UnitService } from '../../../settings-module/services/unit';
import * as fromRoot from '../../../reducers';
import { Unit } from '../../../settings-module/models/unit';

@Component({
  selector: 'mj-job-info-location-card',
  templateUrl: './job-info-location-card.component.html',
  styleUrls: ['./job-info-location-card.component.scss'],
})
export class JobInfoLocationCardComponent
  implements OnInit, OnDestroy, OnChanges {
  locationFormGroup: FormGroup;
  @Input() job: Job;
  @Output() onJobChanged: EventEmitter<Job> = new EventEmitter<Job>();
  @Output() onUnitChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  private currentUnitSubscription: Subscription;

  public hasUserInputNewLocationAndNotYetSavedAsUnitLocation: boolean;

  availableUnits;

  // Map variables
  options: any = {
    layers: [
      tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: 'Job location',
      }),
    ],
    zoom: 13,
  };
  layers: any[] = [];
  center: any = {};

  constructor(
    private _store: Store<fromUnit.State>,
    private _translate: TranslateService,
    private _snackBar: MatSnackBar,
    private _unitService: UnitService,
    private store: Store<fromRoot.State>
  ) {
    this.locationFormGroup = new FormGroup({
      location: new FormControl(''),
      address: new FormControl(''),
    });
  }

  compareUnits(o1: any, o2: any): boolean {
    return o1 && o1.name ? o1.name === o2 : o1 === o2;
  }

  public ngOnDestroy() {
    this.currentUnitSubscription.unsubscribe();
  }

  public ngOnInit() {
    this.currentUnitSubscription = this.store
      .select(fromRoot.getSelectedUnit)
      .subscribe((currentUnit: Unit) => {
        this._store.select(fromUnit.selectUnits).subscribe(units => {
          if (units) {
            this.availableUnits = [units[0], ...units[0].children];
          }
        });
        this.setDefaultLocation(currentUnit);
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.job && this.job) {
      if (this.job.unit_name !== this.locationFormGroup.value.location) {
        this.locationFormGroup.patchValue({
          location: this.job.unit_id,
        });
      }
      if (this.job.address !== this.locationFormGroup.value.address) {
        this.locationFormGroup.patchValue({
          address: this.job.address,
        });
      }
    }
  }

  updateForm(job: Job) {
    if (job.address) {
      this.locationFormGroup.patchValue({
        address: job.address,
      });
    }
  }

  public setDefaultLocation(currentUnit: Unit) {
    let newJob = { ...this.job };
    // the job address isn't set and should be taken from current unit
    if (!this.job.address || !this.job.address.length) {
      if (currentUnit && currentUnit.address) {
        newJob = {
          ...this.job,
          address: currentUnit.address,
        };
        this.onJobChanged.emit(newJob);
      }
    }
    if (!this.job.unit_id) {
      newJob = {
        ...this.job,
        unit_id: currentUnit.id,
      };
    }
    this.onJobChanged.emit(newJob);
    this.updateForm(newJob);
  }

  didSetAddress(place) {
    this.hasUserInputNewLocationAndNotYetSavedAsUnitLocation = true;
    const newJob: Job = {
      ...this.job,
      address: place.formatted_address,
      lat: place.geometry.location.lat(),
      lon: place.geometry.location.lng(),
    };
    this.updateForm(newJob);
    this.onJobChanged.emit(newJob);
  }

  unitChanged(unit) {
    this._unitService
      .getUnit(unit)
      .pipe(take(1))
      .subscribe(unitDetails => {
        const newJob: Job = {
          ...this.job,
          unit_id: unitDetails.id,
          address: unitDetails.address ? unitDetails.address : this.job.address,
          lat: unitDetails.lat,
          lon: unitDetails.lon,
        };
        this.onUnitChanged.emit(true);
        this.onJobChanged.emit(newJob);
        this.updateForm(newJob);
      });
  }

  // onSaveJobLocationAsUnitLocationClicked() {
  //     this.hasUserInputNewLocationAndNotYetSavedAsUnitLocation = false;
  //     const newJob: Job = {
  //         ...this.job
  //     };
  //     this.onJobChanged.emit(newJob);

  //     this._unitService.updateUnit(this.job.unit)
  //         .subscribe(savedUnit => {
  //             this._translate.get('post_job_info_location_saved_snack_bar', {unit_name: savedUnit['name']})
  //                 .subscribe((res) => {
  //                         this._snackBar.open(res, null, {
  //                             duration: 3000,
  //                         });
  //                     }
  //                 );
  //         });
  // }
}
